import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7622970e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar has-background-light is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-menu" }
const _hoisted_3 = { class: "navbar-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-item",
  title: "Список оповещений"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lg fa-bell" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "tag is-danger is-rounded is-normal is-danger" }, "5")
], -1))
const _hoisted_5 = { class: "navbar-item has-dropdown is-hoverable" }
const _hoisted_6 = { class: "navbar-link has-text-weight-semibold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-dropdown is-right" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "navbar-item" }, "Профиль"),
  /*#__PURE__*/_createElementVNode("a", { class: "navbar-item" }, "Выйти")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.navbarContext.user.name), 1),
          _hoisted_7
        ])
      ])
    ])
  ]))
}